export default __webpack_public_path__ + "static/media/Google Applied Digital Skills Send Email.72eb5f5e.webp";